import { Lang, getTranslation } from "@/data/translation";
import { Top20GraphData } from "@/services/13f/cost-estimation";
import { ChartData } from "chart.js";

export const extractCostEstimationData = ({
  lang,
  data,
}: {
  lang: Lang;
  data: Top20GraphData[];
}): ChartData<"bar" | "line"> | null => {
  const { t } = getTranslation({ lang });

  if (data.length === 0) return null;
  const filteredData = data.filter(
    (item) =>
      item.date !== null &&
      item.closePrice !== undefined &&
      item.costPrice !== undefined
  );
  return {
    labels: filteredData.map((item) => item.date),
    datasets: [
      {
        type: "line",
        label: t.chip.closePrice,
        data: filteredData.map((item) => item.closePrice ?? 0),
        borderColor: "#0569A2",
        backgroundColor: "#0569A2",
        yAxisID: "y1",
        pointRadius: 0,
      },
      {
        type: "line",
        label: t.chip.costPrice,
        data: filteredData.map((item) => item.costPrice ?? 0),
        borderColor: "#F06C02",
        backgroundColor: "#F06C02",
        yAxisID: "y",
        pointRadius: 0,
      },
    ],
  };
};
